










































import mixins from 'vue-typed-mixins';
import AuthUtils from '../../utils/AuthUtils';
export default mixins().extend({
  data(): {
    username: string;
    password: string;
  } {
    return {
      username: '',
      password: '',
    };
  },
  methods: {
    async login() {
      try {
        AuthUtils.clear();
        await AuthUtils.login(this.username, this.password);
        try {
          await this.$router.push({ name: 'dashboard' });
        } catch (error) {
          // doesn't matter
        }
      } catch (error) {
        (this.$refs.alert as any).show('login', {
          type: 'error',
          messages: this.$handleAPIError(error, this.$refs.observer),
        });
      }
    },
    async forgotPassword() {
      try {
        await this.$router.push({ name: 'forgot-password' });
      } catch (error) {
        // doesn't matter
      }
    },
  },
});
